<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add College">
      <div class="row">
        <div class="col-md-6 form-group">
          College Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">
            College name is required
          </div>
        </div>
        <!-- <div class="col-md-6 form-group">
          User Name
          <input
            class="form-control"
            type="text"
            v-model="username"
            @focus="usernameEmpty = false"
          />
          <div v-if="usernameEmpty" style="color: red">
            User name is required
          </div>
        </div>
        <div class="col-md-6 form-group" style="position: relative">
          Password
          <input
            id="password"
            type="password"
            class="form-control"
            v-model="password"
            @focus="passwordEmpty = false"
          />
          <i class="far fa-eye" @click="togglePassword()" id="eyeIcon" style="position: absolute; bottom: 10px; right: 25px"></i>
          <div v-if="passwordEmpty" style="color: red">
            Password is required
          </div>
        </div>
         <div class="col-md-6 form-group" style="position: relative">
         Confirm Password
          <input
            id="password1"
            type="password"
            class="form-control"
            v-model="confirmpassword"
            @focus="confirmpasswordEmpty = false,confirmpasswordMatch = false"
          />
          <i class="far fa-eye" @click="togglePassword1()" id="eyeIcon1" style="position: absolute; bottom: 10px; right: 25px"></i>
          <div v-if="confirmpasswordEmpty" style="color: red">
            Confirm Password is required
          </div>
           <div v-if="confirmpasswordMatch" style="color: red">
             Password does not match 
          </div>
        </div> -->
        
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
           @click="addCollege()"
          >Save</b-button
        >
      </div>
       <!-- Loader -->
        <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loader: false,
      nameEmpty: false,
      usernameEmpty: false,
      passwordEmpty: false,
      confirmpasswordEmpty:false,
      confirmpasswordMatch:false,
      name:"",
      username:"",
      password:"",
      confirmpassword:"",
    };
  },
  methods: {
    // togglePassword() {
    //   let passwordField = document.getElementById("password")
    //   const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password'
    //   passwordField.setAttribute("type", type)
    //   let eyeIcon = document.getElementById("eyeIcon")
    //   eyeIcon.classList.toggle('fa-eye-slash')
    // },

    // togglePassword1() {
    //   let passwordField1 = document.getElementById("password1")
    //   const type = passwordField1.getAttribute('type') === 'password' ? 'text' : 'password'
    //   passwordField1.setAttribute("type", type)
    //   let eyeIcon1 = document.getElementById("eyeIcon1")
    //   eyeIcon1.classList.toggle('fa-eye-slash')
    // },

    async addCollege() {
      this.loader = true;
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.name);
      await axios
        .post(`${this.$store.getters.baseUrl}/college/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal("Success", "College added successfully", "success");
            this.$router.push({name: 'Colleges'});
            this.name = "";
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

